export function setConsentDisclosure(trigger, section, isRevealed) {
    if (!trigger || !section) return;
    const revealed = Boolean(isRevealed);
    section.classList.toggle('is-revealed', revealed);
    section.setAttribute('aria-hidden', String(!revealed));
    section.inert = !revealed;
    trigger.setAttribute('aria-expanded', String(revealed));
}
